import { Dialog } from '@alifd/next';
import { createElement } from 'react';
import CustomFooter from './CustomFooter';
import './index.scss';
const HcDialog = (props) => {
    const { children, left, onOk, onClose, onCancel, ...other } = props;
    return (createElement(Dialog, Object.assign({ v2: true, onOk: onOk, onClose: onClose, onCancel: onCancel, footer: createElement(CustomFooter, { left: left, onOk: onOk, onCancel: onCancel }), className: 'custom_dialog' }, other), children));
};
export default HcDialog;
